document.addEventListener('DOMContentLoaded', function() {
    var buttons = document.querySelectorAll('.tabs .tab-item');
    var connectors = document.querySelectorAll('.connectors-list .connector');
    var searchInput = document.querySelector('input[name="connector_keyword"]');
    var div = document.querySelector('.connectors-list');
    if (div) {
        var lang = div.dataset.lang;
    }
    else {
        var lang = 'en_US';
    }
    

    var currentFilter = 'all'; // Conserve le filtre de catégorie actuel

    // Fonction pour filtrer les connecteurs par catégorie et mot-clé
    function filterConnectors() {
        if (searchInput) {

            var keyword = searchInput.value.toLowerCase().trim();
            var i = 0;
            connectors.forEach(function(connector) {
                var category = connector.getAttribute('data-category');
                var connectorName = connector.querySelector('p').textContent.toLowerCase();
                var keywordMatch = connectorName.includes(keyword) || keyword === '';
                var categoryMatch = category.split(' ').includes(currentFilter) || currentFilter === 'all';
    
                if (keywordMatch && categoryMatch) {
                    connector.style.display = '';
                    i++;
                } else {
                    connector.style.display = 'none';
                }
            });
            if (0 == i) {
    
                if ('en_US' == lang) {
                    document.getElementById('connectors-list-msg').textContent = 'Oops! This connector is not yet available';
                }
                else {
                    document.getElementById('connectors-list-msg').textContent = 'Oups ! Ce connecteur n\'est pas encore disponible.';
                }
            }
            else {
                document.getElementById('connectors-list-msg').textContent = '';
            }
        }
    }

    // Événements de clic pour les boutons de catégorie
    buttons.forEach(function(button) {
        button.addEventListener('click', function() {
            // Mettez à jour le filtre de catégorie actuel
            currentFilter = button.getAttribute('data-filter');

            // Réinitialisez la classe active des boutons et définissez-la pour le bouton cliqué
            buttons.forEach(function(btn) { btn.classList.remove('active'); });
            button.classList.add('active');

            // Filtrez les connecteurs avec le nouveau filtre de catégorie et le mot-clé
            filterConnectors();
        });
    });

    // Événement pour la recherche par mot-clé
    if (searchInput) {
        searchInput.addEventListener('input', filterConnectors);
    }

    // Événement pour empêcher la soumission du formulaire lors de l'appui sur Enter
    var form = document.querySelector('.connectors-form');
    if (form) {
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            filterConnectors();
        });
    } 
});